import { PriceObjectEntity } from "@modules/common/priceObject/entities/priceObjectEntity"
import { convertProgramPaymentFromDto } from "@modules/programs/gateway/programDto"
import { type StripeProgramSubscriptionDto } from "@modules/programs/gateway/programInfiniteDto"
import { type ProgramSubscriptionTrial } from "@modules/programs/types/programInfiniteTypes"
import { type ProgramPayment, ProgramSubscriptionStatus } from "@modules/programs/types/programTypes"

export class StripeProgramSubscriptionEntity {
  id: string
  subscriptionId: string
  subscriptionStatus: ProgramSubscriptionStatus
  endPeriodDate: Date | null
  paidPrice: PriceObjectEntity | null
  referencePrice: PriceObjectEntity | null
  nextPayment: PriceObjectEntity | null
  trial: ProgramSubscriptionTrial | null
  payment: ProgramPayment | null

  private constructor(stripeProgramSubscription: StripeProgramSubscriptionEntity) {
    this.id = stripeProgramSubscription.id
    this.subscriptionId = stripeProgramSubscription.subscriptionId
    this.subscriptionStatus = stripeProgramSubscription.subscriptionStatus
    this.endPeriodDate = stripeProgramSubscription.endPeriodDate
    this.paidPrice = stripeProgramSubscription.paidPrice
    this.referencePrice = stripeProgramSubscription.referencePrice
    this.nextPayment = stripeProgramSubscription.nextPayment
    this.trial = stripeProgramSubscription.trial
    this.payment = stripeProgramSubscription.payment
  }

  static fromDto(programId: string, dto: StripeProgramSubscriptionDto): StripeProgramSubscriptionEntity {
    return new StripeProgramSubscriptionEntity({
      id: programId,
      subscriptionId: dto.subscriptionId,
      subscriptionStatus: dto.subscriptionStatus,
      endPeriodDate: dto.periodEndDate ? new Date(dto.periodEndDate) : null,
      paidPrice: dto.paidPrice ? PriceObjectEntity.fromDto(dto.paidPrice) : null,
      referencePrice: dto.referencePrice ? PriceObjectEntity.fromDto(dto.referencePrice) : null,
      nextPayment: dto.nextPayment ? PriceObjectEntity.fromDto(dto.nextPayment) : null,
      trial: dto.trial,
      payment: dto.payment ? convertProgramPaymentFromDto(dto.payment) : null,
    })
  }
}
